/**
 * child-remove-button
 * When the child (add-on) remove button is clicked, removes the PARENT line.
 * Shopify's Nested Cart Lines API automatically cascades the deletion to the
 * child, so both parent and child are cleanly removed in one request.
 */
if (!customElements.get('child-remove-button')) {
  customElements.define(
    'child-remove-button',
    class ChildRemoveButton extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          event.preventDefault();
          const cartItems =
            this.closest('cart-items') || this.closest('cart-drawer-items');
          if (!cartItems) return;
          // Removing the parent cascades to remove this child via Shopify native behavior
          cartItems.updateQuantity(this.dataset.parentIndex, 0);
        });
      }
    }
  );
}
